import React from 'react';

export interface MessageContentProps {
  content: string;
  className?: string;
  isLoading?: boolean;
  children?: React.ReactNode;
}

/**
 * Wrapper component for message content.
 * Can contain custom content (like MarkdownMessage) or simple text.
 */
export const MessageContent = React.forwardRef<
  HTMLDivElement,
  MessageContentProps
>(({ content, className = '', isLoading = false, children }, ref) => {
  return (
    <div
      ref={ref}
      className={['message-content', className].filter(Boolean).join(' ')}
      data-loading={isLoading}
    >
      {children || <p>{content}</p>}
    </div>
  );
});

MessageContent.displayName = 'MessageContent';
